import * as Sentry from '@sentry/browser';

import { FetchParams, Middleware } from '@neptune/shared/core-apis-middleware-domain';

const LONG_REQUEST_THRESHOLD = 2_000;

function completeMeasurement(
  url: string,
  init: FetchParams['init'] & { __startTime?: number },
  status?: number,
) {
  const startTime = init.__startTime;

  if (startTime) {
    const duration = Date.now() - startTime;

    if (duration > LONG_REQUEST_THRESHOLD) {
      Sentry.addBreadcrumb({
        category: 'performance',
        message: 'Long request detected',
        level: 'info',
        data: {
          url,
          status,
          duration: Math.round(duration),
        },
      });
    }
  }
}

export const requestTimingMiddleware: Middleware = {
  async pre(context) {
    const startTime = Date.now();

    (context.init as any).__startTime = startTime;

    return {
      ...context,
      init: {
        ...context.init,
        __startTime: startTime,
      },
    };
  },

  async post({ url, init, response }) {
    completeMeasurement(url, init, response.status);
  },

  async onError({ url, init, response }) {
    completeMeasurement(url, init, response?.status);
  },
};
